import React, { ReactElement } from 'react';
import {
  Link, Loader, Table, Tbody, Td, Th, Thead, Tr,
} from 'idsk-react-components';
import NajnovsiObsahTableItem from '../../../../../model/NajnovsiObsahTableItem';
import dateToString from '../../../../../function/dateToString';
import './najnovsiObsahTable.scss';

interface Props {
  data?: NajnovsiObsahTableItem[],
  loading?: boolean,
  showTyp?: boolean,
  proces?: boolean,
}

const NajnovsiObsahTable = ({
  data,
  loading = false,
  showTyp = false,
  proces = false,
}: Props): ReactElement => (
  <Loader loading={loading}>
    <Table className="najnovsi-obsah-table">
      <Thead>
        <Tr>
          {showTyp && (<Th width="15%">Typ</Th>)}
          <Th width="15%">Číslo</Th>
          {showTyp ? (<Th width="55%">Názov</Th>) : (<Th width="70%">Názov</Th>)}
          {proces ? (<Th width="15%">Začiatok štádia</Th>) : (<Th width="15%">Vyhlásený</Th>)}
        </Tr>
      </Thead>
      <Tbody>
        {data?.map(item => (
          <Tr key={item.id}>
            {showTyp && (<Td>{item.typ}</Td>)}
            <Td>{item.cislo}</Td>
            <Td>
              <Link
                className="nazov-link"
                to={item.redirectUrl}
              >
                {item.nazov}
              </Link>
            </Td>
            <Td>{item.vyhlaseny ? dateToString(item.vyhlaseny, false) : undefined}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Loader>
);

export default NajnovsiObsahTable;
